export const DEFAULT_USER_SITE_ID = 1;
export const MAX_SUBJECTS_PER_USER = 20;

export const ENROLLMENT_STATUSES = [
  { value: 'screening', label: 'Screening' },
  { value: 'included-eligible', label: 'Included-Eligible' },
  { value: 'excluded', label: 'Excluded' },
  { value: 'enrolled', label: 'Enrolled' },
  { value: 'completed', label: 'Completed' },
  { value: 'withdrawn', label: 'Withdrawn' },
  { value: 'discontinued', label: 'Discontinued' }
];

export const initialSubjects = [
    {
        siteName: "GGH-297 - GG Hospital",
        siteId: 1,
        subjectId: 'GGH-001',
        subjectInitials: 'FSD',
        dateOfEnrollment: '21-Aug-2025',
        screeningNumber: 'GGH-001',
        enrollmentStatus: 'Enrolled',
        dataCaptureIcon: true,
        lockStatus: 'unlocked',
        progress: 100
    },
    {
        siteName: 'GGH-297 - GG Hospital',
        siteId: 1,
        subjectId: 'GGH-002',
        subjectInitials: 'RSD',
        dateOfEnrollment: '27-Aug-2025',
        screeningNumber: 'GGH-002',
        enrollmentStatus: 'Screening',
        dataCaptureIcon: true,
        lockStatus: 'unlocked',
        progress: 63
    },
    {
        siteName: 'GGH-297 - GG Hospital',
        siteId: 1,
        subjectId: 'GGH-003',
        subjectInitials: 'LKT',
        dateOfEnrollment: '12-Sep-2025',
        screeningNumber: 'GGH-003',
        enrollmentStatus: 'Screening',
        dataCaptureIcon: true,
        lockStatus: 'locked',
        progress: 0
    },
    {
        siteName: 'GGH-297 - GG Hospital',
        siteId: 1,
        subjectId: 'GGH-004',
        subjectInitials: 'PKD',
        dateOfEnrollment: '03-Sep-2025',
        screeningNumber: 'GGH-004',
        enrollmentStatus: 'Enrolled',
        dataCaptureIcon: true,
        lockStatus: 'unlocked',
        progress: 45
    },
    {
        siteName: 'GGH-297 - GG Hospital',
        siteId: 1,
        subjectId: 'GGH-005',
        subjectInitials: 'TJR',
        dateOfEnrollment: '15-Jun-2025',
        screeningNumber: 'GGH-005',
        enrollmentStatus: 'Completed',
        dataCaptureIcon: true,
        lockStatus: 'locked',
        progress: 100
    }
];